import { createItem, readItems } from "@directus/sdk";
import directus from "./directusClient";
import {
  RELEASE_COLLECTION,
  RELEASE_FIELDS,
  bySyncKey,
  toRelease,
} from "./releaseAdapter";

// Reads and creates delivery-scoped releases. Never updates one: the original
// release time is kept. Whether this teacher may release for a delivery is
// enforced by Directus permissions, not here.
const releaseRepository = {
  find: async (syncKey) => {
    const rows = await directus.request(
      readItems(RELEASE_COLLECTION, {
        fields: RELEASE_FIELDS,
        filter: bySyncKey(syncKey),
        limit: 1,
      })
    );
    return toRelease(rows[0]);
  },

  create: async (payload) =>
    toRelease(
      await directus.request(
        createItem(RELEASE_COLLECTION, payload, { fields: RELEASE_FIELDS })
      )
    ),
};

export default releaseRepository;
